




import CertificateTreatment from "./CertificateTreatment.vue";
import CertificateTreatmentMobile from "./mobile/certificate-treatment/CertificateTreatmentMobile.vue";
import ResponsiveLayout from "../mixin/ResponsiveLayout.vue";

export default {
  components: {
    ResponsiveLayout,
    CertificateTreatment,
    CertificateTreatmentMobile,
  },
  data() {
    return {
      CertificateTreatmentMobile,
      CertificateTreatment,
    };
  },
};
